export { OTP_COOLDOWN_SECONDS, OTP_MAX_ATTEMPTS } from '../../common/MagicSign/constants';

export const PORTAL_ENDPOINTS = {
    INFO: '/magic/sign/public/info',
    OTP_REQUEST: '/magic/sign/public/otp/request',
    OTP_VERIFY: '/magic/sign/public/otp/verify',
    DOCUMENT: '/magic/sign/public/document',
    SIGN: '/magic/sign/public/sign',
} as const;

export const UNAVAILABLE_STATES = ['EXPIRED', 'CANCELLED', 'ALREADY_SIGNED'] as const;

/** Max time to wait for the browser geolocation prompt before signing proceeds without coords. */
export const GEO_TIMEOUT_MS = 8000;

/**
 * Client-side timeout for every public-portal call (info/otp/document/sign). Tighter than the
 * gateway timeout so an unauthenticated signatory never sits on an indefinite spinner — this is
 * a ceiling we control, not the gateway's.
 */
export const PORTAL_REQUEST_TIMEOUT_MS = 20000;

/** Shown when a public-portal request is aborted by PORTAL_REQUEST_TIMEOUT_MS. */
export const PORTAL_TIMEOUT_MESSAGE = 'The request timed out. Please check your connection and try again.';
